module.exports = __webpack_public_path__ + "static/media/8.030b9826.svg";